import React from 'react';
import appTypes from '../../../../constants/types';
import SectionCard from '../../../../components/section-card';
import { TextDataField } from '../../../../components/data-fields';

export const CreateMySQLUserDetails = ({ ticket }) => (
  <SectionCard title="MySQL user information">
    <TextDataField
      name="Region"
      value={ticket && ticket.ticket_data.region} />
    <TextDataField
      name="DB Name"
      value={ticket && ticket.ticket_data.db_identifier} />
    <TextDataField
      name="Username"
      value={ticket && ticket.ticket_data.username} />
    <TextDataField
      name="Email"
      value={ticket && ticket.ticket_data.user_email} />
  </SectionCard>
);

CreateMySQLUserDetails.propTypes = {
  ticket: appTypes.ticket.props,
};
CreateMySQLUserDetails.defaultProps = {
  ticket: appTypes.ticket.default,
};
